module.exports = __webpack_public_path__ + "static/media/logo.a45622b3.svg";